// 替换file url为md5
let ccLoaderGetUrl = cc.loader.getUrl
cc.loader.getUrl = function(basePath, url) {
    if (__DEBUG && getParameterByName('noresmap')) {
        return ccLoaderGetUrl.call(cc.loader, basePath, url)
    }
    let resource = ResManager.getFileMd5(url)
    if (resource) {
        url = resource
    } else {
        cc.warn(url, 'not exist in resource map')
    }
    return ccLoaderGetUrl.call(cc.loader, basePath, url)
}

// 分享专用
cc.loader.getFullUrl = function (url, isHandleSmallRes = false) {
    return cc.loader.getUrl(cc.loader.resPath, isHandleSmallRes ? getRealResourceName(url) : url)
}
function converDataJsonToLuaTable(url, json) {
    if (url.startsWith("config/") || url.startsWith("meta/animations") || url == "pack_config.json" || url === 'meta/safedomain.json') { //packmap和配置不要转LuaTable
        return json
    }else if (json && (json['Content'] || json['C'])  && json['Type']) {// csb文件不需要转成LuaTable
        return json
    } else {
        let label = 'convert ' + url + ' to LuaTable'
        //console.time(label)
        let result = $table(json, false)
        //console.timeEnd(label)
        return result
    }
}

cc.loader.register(['json'], {
    load(realUrl, url, res, cb) {
        cc.loader.loadJson(realUrl, (err, data) => {
            if (err) {
                cb(err)
            } else {
                cb(null, converDataJsonToLuaTable(url, data))
            }
        })
    }
})

// 已经预先parse过
cc.loader.register(['plist'], {
    load(realUrl, url, res, cb) {
        cc.loader.loadJson(realUrl, (err, data) => {
            if (err) {
                cb(err)
            } else {
                cb(null, data)
            }
        })
    }
})

// fix float number
_fntLoader.NUM_EXP = /^(-?\d+)(\.\d+)?$/
_fntLoader._parseStrToObj = function(str) {
    var arr = str.match(this.ITEM_EXP)
    var obj = {}
    if (arr) {
        for (var i = 0, li = arr.length; i < li; i++) {
            var tempStr = arr[i]
            var index = tempStr.indexOf('=')
            var key = tempStr.substring(0, index)
            var value = tempStr.substring(index + 1)
            if (this.NUM_EXP.test(value)) value = parseFloat(value)
            else if (value[0] === '"') value = value.substring(1, value.length - 1)
            obj[key] = value
        }
    }
    return obj
}

// text
cc.loader.register(['strings'], cc._jsonLoader)

function addCacheRefnum(url) {
    let cacheRefnum = cc.loader.cacheRefnum
    let refum = cacheRefnum[url];
    cacheRefnum[url] = refum? refum + 1: 1;
}
function packFileRecursive(data) {
    for (let path in data) {
        if (cc.path.extname(path) == '.skel' ) continue
        let res = cc.loader.getRes(path);
        if (res) {
            addCacheRefnum(path);
            continue
        }
        let file = data[path]
        let ext = cc.path.extname(path)
        if (ext === '.json') {
            cc.loader.cache[path] = converDataJsonToLuaTable(path, file);
            addCacheRefnum(path);
        } else if (ext === '.fnt') {
            cc.loader.cache[path] = _fntLoader.parseFnt(file, path);
            addCacheRefnum(path);
        }else if (ext === '.pack') {
            packFileRecursive(file)
        } else {
            cc.loader.cache[path] = file;
            addCacheRefnum(path);
        }
    }
}
// merged json
cc.loader.register(['pack'], {
    load(realUrl, url, res, cb) {
        cc.loader.loadJson(realUrl, (err, data) => {
            if (err) {
                cb(err)
            } else {
                packFileRecursive(data)
                cb(null, data)
            }
        })
    }
})
